import { FlowGrid, Paragraph, Separator } from '@fs/zion-ui'
import React from 'react'
import FilterInput from '../../FilterInput'
import ManageIndexesButton from './ManageIndexesButton'

/**
 * Displays a section with a description paragraph, manage indexes button, and a filter input
 * for searching persons by name.
 *
 * @component
 * @param {Object} props
 * @param {string} props.filterValue - Current filter text value
 * @param {string} props.description - Description text to display above the actions
 * @param {Function} props.onFilterChange - Callback when filter value changes
 * @param {boolean} [props.showManageIndexesButton=true] - Whether to show the manage indexes button
 * @returns {JSX.Element}
 */
const FilterAndActions = ({ filterValue, description, onFilterChange, showManageIndexesButton = true }) => {
  return (
    <>
      <Separator size="xs" />
      <FlowGrid columnCount={1} orientation="vertical" guttersY="xxs">
        <>
          <Paragraph size="sm">{description}</Paragraph>
          {showManageIndexesButton && <ManageIndexesButton />}
        </>
        <FilterInput filterValue={filterValue} onFilterChange={onFilterChange} textFieldProps={{ dense: true }} />
      </FlowGrid>
      <Separator size="xs" />
    </>
  )
}

export default FilterAndActions
